// Where an agent actually IS, derived from server state alone.
//
// WHY IT EXISTS. The wizard's position lives in localStorage, which is per-BROWSER.
// That is fine for an agent — it is their browser — but in an Agent Services
// read-only preview it is the previewer's position, not the agent's. The first
// preview opened at whatever step Kathie last used, and previewing a second agent
// inherited the first one's position. Neither has anything to do with the agent on
// screen, and "where are they stuck" is the main thing the portal is opened to
// answer.
//
// Deliberately a plain module with no React in it, so it can be tested. It reads
// only /v1/onboarding-gate/status, which is server-owned and cannot be faked by
// the client.

// Returns a step KEY, never an index. The effective step list is dynamic —
// gate.skipTransfers drops listings/escrow/bba — so an index computed here would
// land on a different screen than the one meant.
//
// DESCENDING, strongest evidence first, and that ordering is load-bearing.
// profile_confirmed_at and intro_seen_at were added in August 2026 and are NULL
// for every agent who started before them. Asked in step order — "did they
// confirm their profile? no? → Profile" — a recruit sitting on the welcome form
// with a signed ICA would be sent back to step 1, which is worse than the bug this
// replaces. Checking the far end first means a null early column can only ever
// fail to move somebody forward, never move them back.
export function resumeStepKey(gate) {
  if (!gate) return null;

  // ---- gated pipeline, furthest first ----
  // Only meaningful for a tracked recruit; a transfer-day agent has no intake, so
  // these are all permanently false and would say nothing about them.
  if (gate.tracked) {
    // Past the gate. licenseMoved is TRI-STATE: null means the MLS gave us no
    // office to read, which is NOT "moved" — so anything other than an explicit
    // true keeps them on ADRE. Claiming progress the server has not confirmed is
    // the one thing this must not do.
    if (gate.unlocked) return gate.licenseMoved === true ? "associations" : "adre";
    // The two gate inputs arrive independently. Whichever is missing is the one
    // holding them up; if the ICA is in, the form is what is left — and if BOTH
    // are in, they are on the welcome step watching for an unlock that step-2c
    // has not fired yet.
    if (gate.icaDone) return "welcome";
    if (gate.welcomeDone) return "agreements";
  }

  // ---- the early steps ----
  if (gate.introSeen) return "agreements";
  if (gate.profileConfirmed) return "intro";

  // Nothing recorded at all. Profile rather than Find You: step 0 is the sign-in
  // screen, which is meaningless in a preview — the preview is already
  // authenticated, and the wizard itself moves any signed-in agent off it.
  return "profile";
}
